import { create } from 'zustand';

interface SingleSelectProfileData {
  retailerSku: string;
  skuContentGenerationId: string;
  productTitle?: string;
}

interface SingleSelectProfileState {
  isSingleSelectProfileModalOpen: boolean;
  singleSelectProfileData: SingleSelectProfileData | null;
  openSingleSelectProfileModal: (data: SingleSelectProfileData) => void;
  closeSingleSelectProfileModal: () => void;
  setSingleSelectProfileData: (data: SingleSelectProfileData | null) => void;
}

export const useSingleSelectProfileStore = create<SingleSelectProfileState>((set) => ({
  isSingleSelectProfileModalOpen: false,
  singleSelectProfileData: null,
  openSingleSelectProfileModal: (data: SingleSelectProfileData) => set({ 
    isSingleSelectProfileModalOpen: true, 
    singleSelectProfileData: data 
  }),
  closeSingleSelectProfileModal: () => set({ 
    isSingleSelectProfileModalOpen: false, 
    singleSelectProfileData: null 
  }),
  setSingleSelectProfileData: (data: SingleSelectProfileData | null) => set({ singleSelectProfileData: data })
})); 